import { Injectable } from "@angular/core";
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor,
  HttpErrorResponse
} from '@angular/common/http'
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators'
import { ValidationError, ValidationService } from "../../services/validation.service";

@Injectable()
export class ValidationInterceptor implements HttpInterceptor {
  constructor(private validationService: ValidationService) { }

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    return next.handle(request).pipe(
      catchError((error: HttpErrorResponse) => {
        if (error.status === 400) {
          if (error.error && typeof error.error === 'object') {
            this.validationService.handleValidationErrors(error.error.errors as ValidationError[]);
          }
        }
        return throwError(() => error);
      })
    )
  }
}
